export default {
  SalesLedger: "SalesLedger",
  PurchaseLedger: "PurchaseLedger"
  }
  
  export const AccountTypeDescription = {
  SalesLedger: "Sales Ledger",
  PurchaseLedger: "Purchase Ledger"
  }